import { ProgramModule_view, ProgramModule_withSetState } from "../Fable.Elmish.3.1.0/program.fs.js";
import * as react_dom from "react-dom";
import { Common_lazyView2With } from "./common.fs.js";
import { uncurry2 } from "../fable-library-js.4.24.0/Util.js";

export function Program_Internal_withReactBatchedUsing(lazyView2With, placeholderId, program) {
    let lastRequest = undefined;
    return ProgramModule_withSetState((model, dispatch) => {
        if (lastRequest != null) {
            const r = lastRequest;
            window.cancelAnimationFrame(r);
        }
        lastRequest = window.requestAnimationFrame((_arg) => {
            react_dom.render(lazyView2With((x) => ((y) => (x === y)), ProgramModule_view(program), model, dispatch), document.getElementById(placeholderId));
        });
    }, program);
}

export function Program_Internal_withReactSynchronousUsing(lazyView2With, placeholderId, program) {
    return ProgramModule_withSetState((model, dispatch) => {
        react_dom.render(lazyView2With((x) => ((y) => (x === y)), ProgramModule_view(program), model, dispatch), document.getElementById(placeholderId));
    }, program);
}

export function Program_Internal_withReactHydrateUsing(lazyView2With, placeholderId, program) {
    return ProgramModule_withSetState((model, dispatch) => {
        react_dom.hydrate(lazyView2With((x) => ((y) => (x === y)), ProgramModule_view(program), model, dispatch), document.getElementById(placeholderId));
    }, program);
}

/**
 * Renders React root component inside html element identified by placeholderId.
 * Uses `requestAnimationFrame` to batch updates to prevent drops in frame rate.
 * NOTE: This may have unexpected effects in React controlled inputs, see https://github.com/elmish/react/issues/12
 */
export function Program_withReactBatched(placeholderId, program) {
    return Program_Internal_withReactBatchedUsing((equal, view, state, dispatch) => Common_lazyView2With(uncurry2(equal), uncurry2(view), state, dispatch), placeholderId, program);
}

/**
 * Renders React root component inside html element identified by placeholderId.
 * New renders are triggered immediately after an update.
 */
export function Program_withReactSynchronous(placeholderId, program) {
    return Program_Internal_withReactSynchronousUsing((equal, view, state, dispatch) => Common_lazyView2With(uncurry2(equal), uncurry2(view), state, dispatch), placeholderId, program);
}

export function Program_withReact(placeholderId, program) {
    return Program_Internal_withReactBatchedUsing((equal, view, state, dispatch) => Common_lazyView2With(uncurry2(equal), uncurry2(view), state, dispatch), placeholderId, program);
}

export function Program_withReactUnoptimized(placeholderId, program) {
    return Program_Internal_withReactSynchronousUsing((equal, view, state, dispatch) => Common_lazyView2With(uncurry2(equal), uncurry2(view), state, dispatch), placeholderId, program);
}

/**
 * Renders React root component inside html element identified by placeholderId using `React.hydrate`.
 */
export function Program_withReactHydrate(placeholderId, program) {
    return Program_Internal_withReactHydrateUsing((equal, view, state, dispatch) => Common_lazyView2With(uncurry2(equal), uncurry2(view), state, dispatch), placeholderId, program);
}

